import { WebHaptics } from "web-haptics";

export type HapticStyle =
  | "light"
  | "selection"
  | "nudge"
  | "success"
  | "error"
  | "buzz";

const instance = new WebHaptics();
let enabled = true;

/** Toggle haptic feedback globally */
export function setHapticsEnabled(on: boolean): void {
  enabled = on;
}

export function getHapticsEnabled(): boolean {
  return enabled;
}

export function haptic(style: HapticStyle): void {
  if (!enabled) return;
  instance.trigger(style);
}
